import { render, staticRenderFns } from "./PostDetailsComponent.vue?vue&type=template&id=118c9703&"
import script from "./PostDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./PostDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports